export const grid = ({ quantityDataAreVisible }) => ({
    marginTop: 40,
    display: 'grid',
    gridTemplateColumns: quantityDataAreVisible ? '50fr repeat(3, 11fr) 7fr 2fr' : '58fr repeat(2, 20fr) 2fr',
    gridColumnGap: 16,
    gridRowGap: 21,
    alignItems: 'center',
});
